/**
 * StatusBadge — colored pill matching Flutter `ShipmentStatusChip`.
 */
import { useTranslation } from 'react-i18next';
import type { ShipmentStatus } from '@/types/shipment';

const STATUS_COLOR: Record<ShipmentStatus, { bg: string; fg: string; label: string }> = {
  pending:                  { bg: '#FEF3C7', fg: '#92400E', label: 'بانتظار سائق' },
  awaiting_approval:        { bg: '#FDE68A', fg: '#7C2D12', label: 'بانتظار موافقتك' },
  awaiting_sender_approval: { bg: '#FDE68A', fg: '#7C2D12', label: 'بانتظار موافقتك' },
  accepted:                 { bg: '#DBEAFE', fg: '#1E40AF', label: 'قَبِلها سائق' },
  picked_up:                { bg: '#BFDBFE', fg: '#1E40AF', label: 'تم الاستلام' },
  in_transit:               { bg: '#DDD6FE', fg: '#5B21B6', label: 'في الطريق' },
  at_center:                { bg: '#E9D5FF', fg: '#6B21A8', label: 'في المركز' },
  out_for_delivery:         { bg: '#FED7AA', fg: '#9A3412', label: 'للتسليم' },
  delivered:                { bg: '#BBF7D0', fg: '#166534', label: 'تم التسليم' },
  cancelled:                { bg: '#FEE2E2', fg: '#991B1B', label: 'ملغاة' },
  return_requested:         { bg: '#FFE4E6', fg: '#9F1239', label: 'إرجاع مطلوب' },
  returned:                 { bg: '#FECACA', fg: '#7F1D1D', label: 'مرتجعة' },
  disputed:                 { bg: '#F3E8FF', fg: '#581C87', label: 'متنازَع عليها' },
};

export function StatusBadge({ status, size = 'sm' }: { status: ShipmentStatus; size?: 'sm' | 'md' }) {
  const { t } = useTranslation();
  const cfg = STATUS_COLOR[status] || { bg: '#E5E7EB', fg: '#374151', label: status };
  const padding = size === 'md' ? 'px-3 py-1 text-sm' : 'px-2.5 py-0.5 text-xs';
  return (
    <span
      className={`inline-block rounded-full font-semibold ${padding}`}
      style={{ background: cfg.bg, color: cfg.fg }}
    >
      {t(`status.${status}`, cfg.label)}
    </span>
  );
}
